import { memo, forwardRef } from 'react'
import classNames from 'classnames'
import { createUseStyles, useTheme } from 'react-jss'
import DelayLink from '@/components/DelayLink'
import { CURRENT_LANG } from '@/constants'
import style from './style'

const useStyles = createUseStyles(style)

const Logo = forwardRef(({
  tabIndex,
  className,
}, ref) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
      ref={ref}
    >
      <DelayLink
        to={CURRENT_LANG}
        className={classes.logo}
        tabIndex={tabIndex}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 36.71"
          width={theme.header.logo.width}
          height={theme.header.logo.height}
          fill={theme.header.logo.fill}
        >
          <path d="M21.97 0v26.42H18.3V14.09H3.67v12.32H0V0h3.67v10.79H18.3V0h3.67Zm21.77 26.42h-3.43v-3.83c-1.41 2.42-3.87 4.15-6.97 4.15-4.23 0-7.26-2.86-7.26-7.18V6.1h3.43v12.82c0 2.74 1.73 4.72 4.6 4.72 3.79 0 6.21-3.27 6.21-8.63V6.1h3.43v20.32ZM47.69 6.1h3.43v3.83c1.01-2.42 3.02-4.15 6.13-4.15 3.31 0 5.89 1.53 6.61 4.27 1.09-2.42 3.51-4.27 6.57-4.27 4.35 0 7.1 2.74 7.1 7.02v13.63H74.1V13.47c0-2.78-1.57-4.68-4.43-4.68-3.47 0-5.36 3.1-5.36 7.42v10.2h-3.43V13.47c0-2.78-1.57-4.68-4.39-4.68-3.47 0-5.36 3.1-5.36 7.42v10.2H47.7V6.1Zm52.3 14.16-2.77-1.2c-1.59 3.67-6.2 5.19-9.55 4.5-1.63-.34-4.36-1.46-4.36-5.19 0-3.07.92-5.61 2.66-7.34 1.42-1.41 3.31-2.22 5.2-2.22s3.9.82 3.9 3.13c0 1.14-.89 1.97-1.42 2.37-1.71 1.28-4.33 1.65-6.68.96l-.86 2.9c3.27.98 6.85.43 9.35-1.43 1.7-1.27 2.64-2.97 2.64-4.79 0-3.62-2.85-6.16-6.93-6.16-2.68 0-5.36 1.13-7.34 3.1-1.62 1.61-3.55 4.57-3.55 9.48 0 4.16 2.59 7.29 6.77 8.15.73.15 1.49.23 2.27.23 4.17 0 8.8-2.16 10.67-6.48ZM47.67 34.09c0-1.74 1.2-2.62 2.54-2.62 1.24 0 2.18.73 2.31 1.79h-1.01c-.07-.56-.62-.95-1.3-.95-.89 0-1.57.62-1.57 1.79s.67 1.78 1.57 1.78c.7 0 1.25-.39 1.33-.94h.97c-.1 1.06-1.04 1.79-2.3 1.79-1.36 0-2.54-.88-2.54-2.62Zm12.35 1.37h-1.98l-.44 1.19h-1l1.97-5.13h.91l1.98 5.13h-1l-.44-1.19Zm-.29-.82-.69-1.88-.69 1.88h1.38Zm6.23-3.11h2.06c1.07 0 1.71.66 1.71 1.59s-.64 1.59-1.71 1.59h-1.08v1.95h-.97v-5.13Zm2.01 2.37c.57 0 .81-.37.81-.78s-.23-.78-.81-.78h-1.04v1.55h1.04Zm6.31-2.37h.97v5.13h-.97v-5.13Zm7.02.84h-1.55v-.84h4.07v.84h-1.55v4.29h-.97v-4.29Zm9.41 3.1h-1.98l-.44 1.19h-1l1.97-5.13h.91l1.98 5.13h-1l-.44-1.19Zm-.29-.82-.69-1.88-.69 1.88h1.38Zm6.12 1.09v-4.2h.97v4.03c0 .16.1.26.26.26h2.15v.84h-2.44c-.6 0-.93-.32-.93-.92Z" />
        </svg>
      </DelayLink>
    </div>
  )
})

export default memo(Logo)
